<template>
<CCard>
    <CCardBody class="text-center">
        <CImg class="w-100" style="max-width:200px;" src="//statics.affili.ir/storage/assets/empty-page.png" />

        <div class="font-lg my-3">
            <slot name="content"></slot>
            <slot name="button"></slot>
        </div>
    </CCardBody>
</CCard>
</template>

<script>
export default {
    name: 'EmptyPage',
}
</script>